export enum EventTypeEnum {
    HTTP_ERROR = 'http_error',
    HTTP_REQUEST = 'http_request',
    HTTP_RESPONSE = 'http_response',
    LOGIN = 'login',
    LOGOUT = 'logout',
    TOKEN_REFRESHED = 'token_refreshed',
    ONE_DRIVE_ERROR = 'one_drive_error',
}
